import React, { useMemo } from 'react';
import { ReactComponent as DownloadIcon } from './../../addPortfolioToInvitePopup/assets/download.svg';
import PropTypes from 'prop-types';

import './DownloadFile.css';

const DownloadFile = ({ file }) => {
    const href = useMemo(
        () =>
            `${process.env.REACT_APP_GOOGLE_CLOUD_ORIGIN}${process.env.REACT_APP_STORAGE_BUCKET}/${file.path}`,
        [file]
    );

    return (
        <div className="download-file-wrap">
            <div className="download-file-name">{file.name}</div>
            <a href={href} download target="_blank" rel="noreferrer" className="download-icon-wrap">
                <DownloadIcon />
            </a>
        </div>
    );
};

DownloadFile.propTypes = {
    file: PropTypes.any.isRequired,
};

export default DownloadFile;
